/* eslint-disable no-param-reassign, no-nested-ternary */
export const COURSES_PAGE_SIZE =
  typeof window !== 'undefined' && window.innerWidth < 768 ? 15 : 36;
export const COURSES_SEARCH_PAGE_SEARCH =
  typeof window !== 'undefined' && window.innerWidth < 768 ? 10 : 36;

export const reduceById = (obj, item) => {
  obj[item.id] = { ...item };

  return obj;
};

// Hey! The BundleDetail and BundleHome components depends of this functions

export const formatDuration = seconds => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds / 60) % 60);
  let format = `${minutes}m`;

  if (hours) {
    format = `${hours}h ${format}`;
  }
  return format;
};

export const formatExpensiveData = item => ({
  ...item,
  score: item.score ? item.score.average : 0,
  id: item.originalId,
  isEnrolled: item.isEnrollment,
});

const formatItem = (buyUrl, item) => ({
  ...item,
  id: item.originalId,
  duration: formatDuration(item.duration),
  buyUrl,
  score: item.score ? item.score.average : 0,
  isEnrolled: item.isEnrollment,
});

const formatItemV2 = (buyUrl, item) => ({
  ...item,
  id: item.originalId,
  // duration: formatDuration(item.duration),
  category: item.categoryObj,
  subcategory:
    typeof item.subcategory === 'string'
      ? { name: item.subcategory }
      : item.subcategory,
  buyUrl,
  isEnrolled: item.isEnrollment,
});

export const formatCourse = course =>
  formatItem(`/shopping-cart/course/${course.originalId}/`, course);

export const formatCourseV2 = course =>
  formatItemV2(`/shopping-cart/course/${course.originalId}/`, course);

export const checkIfisInShoppingCart = courseIdsOwned => course => ({
  ...course,
  inShoppingCart: courseIdsOwned.indexOf(course.id || course.originalId) > -1,
});

export const formatBundle = bundle =>
  formatItem(`/shopping-cart/bundle/${bundle.originalId}/`, bundle);
